import * as React from 'react'

import { AppContextType, AppContext } from './AppContext.context'

export const AppContextWrapper: React.FC = React.memo(({ children }) => {
  const [state, setState] = React.useState({
    appDataLoaded: false,
    isRefetchingAppData: false,
  })
  const { appDataLoaded, isRefetchingAppData } = state

  const handleAppDataLoaded = React.useCallback(() => {
    setState({
      appDataLoaded: true,
      isRefetchingAppData: false,
    })
  }, [])

  const setIsRefetchingAppData = React.useCallback((value = true) => {
    setState(prevState => ({
      ...prevState,
      isRefetchingAppData: value,
    }))
  }, [])

  /**
   * Memoized value for passing into AppContext
   */
  const contextValue: AppContextType = React.useMemo(
    (): AppContextType => ({
      isFullyInitialized: appDataLoaded,
      isRefetchingAppData,
      onAppDataLoaded: handleAppDataLoaded,
      setIsRefetchingAppData,
    }),
    [
      appDataLoaded,
      handleAppDataLoaded,
      isRefetchingAppData,
      setIsRefetchingAppData,
    ],
  )

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  )
})
